import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isDashboardInNativeMode } from 'utils/dashboard';
import { SHELL_ORIGIN } from 'utils/config';
import { ROUTE_CHANGE_MESSAGE } from 'utils/shell-messages';

export const useNativeRouteSync = (): void => {
  const location = useLocation();

  useEffect(() => {
    if (!isDashboardInNativeMode()) return;

    window.parent.postMessage(
      {
        type: ROUTE_CHANGE_MESSAGE,
        path: `${location.pathname}${location.search}`,
      },
      SHELL_ORIGIN || '*'
    );
  }, [location.pathname, location.search]);
};

const NativeRouteSync = (): null => {
  useNativeRouteSync();
  return null;
};

export default NativeRouteSync;
